"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

window.addEventListener(
  "load",
  () => {
    gsap
      .timeline({
        defaults: {
          ease: "power2.out",
        },
      })
      /* square */
      .to(
        ".top-kv__wrapper .top__square--gray01",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.25,
          },
        },
        0.15
      )
      .to(
        ".top-kv__wrapper .top__square--gray03",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.25,
          },
        },
        0
      )
      .to(
        ".top-kv__wrapper .top__square--red",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.25,
          },
        },
        0.2
      )
      .to(
        ".top-kv__wrapper .top__square--white",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.25,
          },
        },
        0.05
      )
      .to(
        ".top-kv__wrapper .top__square--gray02",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.25,
          },
        },
        0.1
      )
      .to(
        ".top-kv__wrapper",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.25,
          },
        },
        0
      )
      /* img */
      .to(
        ".top-kv__group",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          xPercent: 0,
          stagger: {
            from: "random",
            amount: 0.3,
          },
        },
        0.8
      )
      .to(
        ".top-kv__img",
        {
          ease: "Power2.easeInOut",
          duration: 0.5,
          "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
          stagger: {
            from: "random",
            amount: 0.3,
          },
        },
        0.8
      )
      /* text */
      .to(
        ".top-kv__txt--portrait",
        {
          ease: "Circ.easeInOut",
          duration: 0.8,
          "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          stagger: {
            from: "random",
            amount: 0.2,
          },
        },
        1.4
      )
      .to(
        ".top-kv__txt--landscape",
        {
          ease: "Circ.easeInOut",
          duration: 0.8,
          "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
          stagger: {
            from: "random",
            amount: 0.2,
          },
        },
        1.4
      )
      .to(
        ".top-kv-ttl",
        {
          ease: "Power1.easeIn",
          duration: 1.8,
          opacity: 1,
          filter: "blur(0px)",
          scale: 1,
        },
        1.8
      )
      .to(
        ".top-kv-ttl__bg",
        {
          ease: "Power1.easeIn",
          duration: 1.8,
          filter: "brightness(1)",
          opacity: 1,
        },
        1.8
      )
      .add(function () {
        document.querySelector(".top-kv").classList.add("exit");
      }, 3.6);
  },
  false
);

const activeArea = document.querySelector(".top");
const target = document.querySelectorAll(".top__move");
const targetImg = document.querySelectorAll(".top-kv__group");
const xCenter = window.innerWidth / 2;
const yCenter = window.innerHeight / 2;
//中心からマウスの距離の10分１移動
const parallaxVal = [50, 10, 25, 40, 30, 50, 10, 25, 40, 30];
let parallaxImgVal = [30, 50, 70, 90, 110, 130, 150];
parallaxImgVal = shuffleArray(parallaxImgVal);

// マウスがパララックスエリアに入った時のイベント
activeArea.addEventListener("mousemove", (e) => {
  // ベタ
  target.forEach((el, index) => {
    const x = setDistance(xCenter, e.pageX, parallaxVal[index]);
    const y = setDistance(yCenter, e.pageY, parallaxVal[index]);
    el.style.transform = `translate(${-x}px, ${-y}px)`;
  });
  // 画像
  targetImg.forEach((el, index) => {
    const x = setDistance(xCenter, e.pageX, parallaxImgVal[index]);
    const y = setDistance(yCenter, e.pageY, parallaxImgVal[index]);
    el.style.transform = `translate(${-x}px, ${-y}px)`;
  });
});

function setDistance(center, position, ratio) {
  return (center - position) / ratio;
}
function shuffleArray(inputArray) {
  return inputArray.sort(() => Math.random() - 0.5);
}

// apply parallax effect to any element with a data-speed attribute
/*
gsap.to("[data-speed]", {
  y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window),
  ease: "none",
  scrollTrigger: {
    start: 0,
    end: "max",
    invalidateOnRefresh: true,
    scrub: 0,
  },

  onStart: () => {
    console.log((1 - parseFloat(0.75)) * ScrollTrigger.maxScroll(window));
  }
});

// リニューアル前へのリンク
ScrollTrigger.create({
  trigger: ".top-news__main",
  start: "top bottom",
  endTrigger: ("footer"),
  end: "top ",
  toggleClass: {targets: ".top-prev", className: "active"},
  toggleActions: 'play none none reverse'
});

*/

const anim = document.querySelectorAll(".top-sec");
anim.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to(
          item.querySelectorAll(".top__square"),
          {
            ease: "Circ.easeInOut",
            duration: 0.5,
            x: 0,
            stagger: {
              from: "random",
              amount: 0.25,
            },
          },
          0
        )
        .to(
          item.querySelectorAll(".top-sec__wrapper"),
          {
            ease: "Circ.easeInOut",
            duration: 0.5,
            x: 0,
            stagger: {
              from: "random",
              amount: 0.25,
            },
          },
          0
        );
    },
  });
});

// 仕事紹介ページへのリンク
ScrollTrigger.create({
  trigger: ".top-news__main",
  start: "top bottom",
  endTrigger: ".footer",
  end: "top bottom ",
  toggleClass: { targets: ".top-fixed-area", className: "active" },
  toggleActions: "play none none reverse",
});
